/**
 * 서버 관리 서비스 (관리자 전용)
 */

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.ilouli.com';

const TOKEN_KEY = 'ilouli_token';

// 쿠키에서 토큰 가져오기 (api.js와 동일한 방식)
const getToken = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === TOKEN_KEY) {
      return decodeURIComponent(value);
    }
  }
  // 백업: localStorage에서 시도
  try {
    const backupToken = localStorage.getItem(`${TOKEN_KEY}_backup`);
    if (backupToken) return backupToken;
  } catch (e) {
    console.warn('Failed to get backup token:', e);
  }
  return null;
};

// 공통 헤더
const getHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

/**
 * 시스템 정보 조회
 */
export const getSystemInfo = async () => {
  const response = await fetch(`${API_BASE}/api/admin/server/system`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * PM2 프로세스 목록 조회
 */
export const getPM2Processes = async () => {
  const response = await fetch(`${API_BASE}/api/admin/server/pm2`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * PM2 프로세스 재시작
 */
export const restartPM2Process = async (name) => {
  const response = await fetch(`${API_BASE}/api/admin/server/pm2/${name}/restart`, {
    method: 'POST',
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * PM2 프로세스 로그 조회
 */
export const getPM2Logs = async (name) => {
  const response = await fetch(`${API_BASE}/api/admin/server/pm2/${name}/logs`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * Nginx 상태 조회
 */
export const getNginxStatus = async () => {
  const response = await fetch(`${API_BASE}/api/admin/server/nginx`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * 데이터베이스 정보 조회
 */
export const getDatabaseInfo = async () => {
  const response = await fetch(`${API_BASE}/api/admin/server/database`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

/**
 * 로그 조회
 */
export const getLogs = async (type) => {
  const response = await fetch(`${API_BASE}/api/admin/server/logs?type=${type}`, {
    headers: getHeaders(),
    credentials: 'include'
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export default {
  getSystemInfo,
  getPM2Processes,
  restartPM2Process,
  getPM2Logs,
  getNginxStatus,
  getDatabaseInfo,
  getLogs
};
